require('./bootstrap');
require('popper.js');
require('@fortawesome/fontawesome-free/js/all.min')

window.Vue = require('vue').default;

import App from './components/App'
import ImagePage from './components/imagePage'
import WorkerPage from './components/workerPage'
import ThankPage from './components/thakyouPage'
import PausePage from './components/pausePage'

//Vue.component('tablet-screen', require('./components/tabletScreen').default);

Vue.component('app', App);
Vue.component('image-page', ImagePage);
Vue.component('worker-page', WorkerPage);
Vue.component('thank-page', ThankPage);
Vue.component('pause-page', PausePage);

const app = new Vue({
    el: '#app',
    components: {
        'app': App,
        'worker-page': WorkerPage,
        'image-page': ImagePage,
        'thank-page': ThankPage,
        'pause-page': PausePage
    },
    render: h => h(App)
});